import React, { useEffect, useState } from 'react';

import { partitionOptions } from '@components/dimensions/utils/partition';
import { useQueryDimensionData } from '@components/mapping-panel/api';
import { useGetSankeyDimensions } from '@src/emp-3.0/api/queryHooks';
import { dimensionValueLabelRender } from '@src/emp-3.0/components/Sankey/components/CompactDualSelect';
import EventBreakDown from '@src/emp-3.0/components/Sankey/components/EventBreakDown';
import { useSankeyStore } from '@src/emp-3.0/components/Sankey/store';
import { IEventBreakdown } from '@src/emp-3.0/types';
import { parseDataToOptions } from '@src/emp-3.0/utils/parse';

import { LANDING_EVENTS_WITH_MAX_DIMENSION_RULES_COUNT } from '../../constants';

const EVENT_NAME = 'event_name';
const EMPTY_ARRAY = [];

interface IProps {
  onDimensionChange?: (dimensions: any) => void;
  onEventNameChange?: (eventName: string) => void;
}

const LandingEvent: React.FC<IProps> = (props) => {
  const { sankeyRequestBody } = useSankeyStore((state) => state);
  const { filters, landing_events, interval } = sankeyRequestBody;

  const [landingEvent, setLandingEvent] = useState<IEventBreakdown>({
    event_name: '',
    breakdowns: [],
  });

  const landing_events_str = JSON.stringify(landing_events);

  useEffect(() => {
    const landingEvent = landing_events[0];
    const eventData = {
      event_name: landingEvent.event_name,
      breakdowns: landingEvent.filters,
    };
    setLandingEvent(eventData);
  }, [landing_events_str]);

  const { data: dimensionList = EMPTY_ARRAY, isLoading: isDimensionLoading } =
    useGetSankeyDimensions();

  const { data: eventNameData = EMPTY_ARRAY, isFetching: isEventNameLoading } =
    useQueryDimensionData(
      {
        fields: [EVENT_NAME],
        interval: interval,
        filters: filters,
        params: {
          src: 'trends',
        },
      },
      500,
    );

  const { defaultOptions: eventDimensionOptions } = partitionOptions(
    dimensionList.filter((item) => item.can_breakdown === 1),
  );

  const { defaultOptions: dimensionOptions } = partitionOptions(
    dimensionList.filter((item) => item.can_filter === 1),
    (dimension) => filters.some((item) => item[0].field === dimension.dimension_name),
  );

  const eventNameOptions = parseDataToOptions(eventNameData, {
    label: EVENT_NAME,
    value: EVENT_NAME,
    labelRender: dimensionValueLabelRender,
  });

  const onLandingEventAddDimension = () => {
    landingEvent.breakdowns.push([
      {
        field: '',
        op: 'eq',
        value: [],
      },
    ]);
    setLandingEvent(landingEvent);
    props.onDimensionChange?.([...landingEvent.breakdowns]);
  };

  const onLandingEventNameChange = (eventName) => {
    landingEvent.event_name = eventName;
    setLandingEvent(landingEvent);
    props.onEventNameChange?.(eventName);
  };
  const onLandingEventDimensionChange = (dimensions) => {
    landingEvent.breakdowns = [...dimensions];
    setLandingEvent(landingEvent);
    props.onDimensionChange?.([...dimensions]);
  };

  const buttonText = landingEvent.breakdowns.length ? `(${landingEvent.breakdowns.length})` : '';

  return (
    <EventBreakDown
      eventData={landingEvent}
      eventOptions={eventNameOptions}
      filters={filters}
      interval={interval}
      loading={false}
      showDelete={false}
      addDimensionButtonProps={{
        text: `Add Dimension ${buttonText}`,
        show: landingEvent?.breakdowns.length < LANDING_EVENTS_WITH_MAX_DIMENSION_RULES_COUNT,
      }}
      onEventNameChange={onLandingEventNameChange}
      onDimensionChange={onLandingEventDimensionChange}
      onAddDimension={onLandingEventAddDimension}
      compactDualSelectProps={{
        dimensionSelectProps: {
          options: eventDimensionOptions,
          loading: isDimensionLoading,
        },
        dimensionValueSelectProps: {
          mode: undefined,
          allowClear: false,
        },
      }}
    />
  );
};

export default LandingEvent;
